module.exports = __webpack_public_path__ + "assets/img/wtsD.cf756281.png";